import { render, staticRenderFns } from "./CategoryDetails.vue?vue&type=template&id=23aabb9a&"
import script from "./CategoryDetails.vue?vue&type=script&lang=ts&"
export * from "./CategoryDetails.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports